<template>
  <div>
    <PrinterHeader :img_header="header_image" header="ตั้งค่าไอพีปริ้นเตอร์"/>
    <Printer_ip_config/>
  </div>
</template>

<script>
import PrinterHeader from "@/components/maintenance/printerfix/menu/PrinterHeader";
import HeaderImage from "@/assets/settings.png";
import Printer_ip_config from "@/components/maintenance/printerfix/Printer_ip_config";
export default {
  name: "PrinterIPConfig",
  components: {
    Printer_ip_config,
    PrinterHeader
  },
  data(){
    return{
      header_image:HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
